/* eslint-disable react/jsx-props-no-spreading */
/**
 * Props spreading is required because the parent component is fully customizable
 * So, we need to pass all the props to the parent component
 * That are typed as React.HTMLAttributes<HTMLDivElement>, the correct
 * types for a div element.
 */
import React from 'react';
import clsx from 'clsx';
import { FileIcon, FolderIcon } from './FileExplorerIcons';

interface FileExplorerGridItemProps extends React.HTMLAttributes<HTMLDivElement> {
  kind: 'file' | 'folder';
  nodeTitle: string;
  actionsDropdown: React.ReactNode;
  isNewlyAdded?: boolean;
  onDoubleClick?: (e: React.MouseEvent<HTMLDivElement>) => void;
  updatedAt?: string;
}

export function FileExplorerGridItem(
  { kind, isNewlyAdded, ...props }: FileExplorerGridItemProps) {
  const {
    actionsDropdown, nodeTitle, onDoubleClick, updatedAt, ...rest
  } = props;

  const updatedAtDate = updatedAt ? new Date(updatedAt) : null;
  const updatedAtDateString = updatedAtDate ? `Actualizado el ${updatedAtDate.toLocaleString('es-CL', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  })}` : '';

  const handleDoubleClick = (e: React.MouseEvent<HTMLDivElement>) => {
    e.preventDefault();
    onDoubleClick?.(e);
  };
  const icon = kind === 'file'
    ? <FileIcon height={30} width={30} />
    : <FolderIcon height={30} width={30} />;

  return (
    <div
      className={clsx('file-explorer-grid-item')}
      data-newly-added={isNewlyAdded}
      title={nodeTitle}
      onDoubleClick={kind === 'folder' ? handleDoubleClick : onDoubleClick}
      style={{ userSelect: 'none' }}
      {...rest}
    >
      <div className="file-explorer-grid-item__header">
        {actionsDropdown}
      </div>
      <div className="file-explorer-grid-item__body">
        {icon}
      </div>
      <div className={
        clsx('file-explorer-grid-item__footer', {
          'pb-2': updatedAtDateString,
        })
      }
      >
        <span className="d-block text-truncate">
          {nodeTitle}
        </span>
        {updatedAtDateString && (
          <span title={updatedAtDateString} className="file-explorer-grid-item__footer-updated-at fs-xs text-muted d-block text-truncate">
            {updatedAtDateString}
          </span>
        )}
      </div>
    </div>
  );
}
